<span>
  {{ connection$ | async }}
</span>